const MoreHorizontal = () => (
  <>
    <path
      fill="currentColor"
      d="M4.77 12q0-.507.362-.87.36-.36.869-.36.507 0 .869.36.362.362.362.87 0 .507-.362.87-.36.36-.87.36-.507 0-.868-.36A1.19 1.19 0 0 1 4.77 12m6 0q0-.507.362-.87.36-.36.869-.36.507 0 .869.36.362.362.362.87 0 .507-.362.87-.36.36-.87.36-.507 0-.868-.36a1.19 1.19 0 0 1-.362-.87m6 0q0-.507.361-.87.361-.36.87-.36.507 0 .869.36.361.362.361.87 0 .507-.361.87-.36.36-.87.36-.507 0-.869-.36a1.19 1.19 0 0 1-.361-.87"
    />
  </>
)
export default MoreHorizontal
